// Components do projeto
import KOGCollapse from "../kogCollapse/kogCollapse";
import LoadingComponent from "../loading/loadingComponent";
import AttachmentCard from "./attachmentCard";

// Utils e API
import { getTranslateByKey, isNullUndefined } from "@/main/services/utils";
import { ImportQuoteFileResponse } from "@/main/models/response";
import { PaginationNotFound } from "../paginationGrid/paginationTools";

// Styles
import * as S from "./styles";

interface ICollapseFilesProps {
	files: ImportQuoteFileResponse[];
	isLoading: boolean;
	expanded: boolean;
	onToggle: (expanded: boolean) => void;
	onDeleteFile: (guidQuoteAttachment: string | null) => void;
	onDownloadFile: (guidFileImport: string, fileName: string, fileExtension: string) => void;
}

function CollapseFiles({ files, isLoading, expanded, onToggle, onDeleteFile, onDownloadFile }: ICollapseFilesProps) {
	const generateNameFile = (file: ImportQuoteFileResponse) =>
		`${file.fileName}.${file.fileExtension.toLocaleLowerCase()}`;

	const generateTooltipMessageFile = (file: ImportQuoteFileResponse) => {
		const getUploaderInfo = () =>
			isNullUndefined(file.username) ? "" : `${file.username} - ${file.uploadDateFormatted}`;
		const getFormattedOrderNr = () =>
			isNullUndefined(file.orderNr) ? "" : `${getTranslateByKey("information.orderNr")}: ${file.orderNr}`;
		const getFormattedQuoteCode = () =>
			isNullUndefined(file.quoteCode) ? "" : `${getTranslateByKey("information.quotenr")}: ${file.quoteCode}`;

		const tooltipSections = [
			getFormattedOrderNr(),
			getFormattedQuoteCode(),
			generateNameFile(file),
			getUploaderInfo(),
			file.comment ?? "",
		].filter(Boolean);

		return tooltipSections.join("\n");
	};

	return (
		<KOGCollapse
			header={<span style={{ fontWeight: "bold" }}>{getTranslateByKey("information.files")}</span>}
			isOpenCollapseinitial={false}
			forceCollapseTrigger={!expanded}
			onCustomCollapse={onToggle}
			content={
				isLoading ? (
					<LoadingComponent />
				) : (
					<div style={{ maxHeight: "300px", overflowY: "auto" }}>
						{files.length === 0 ? (
							<PaginationNotFound typeGrid="default" />
						) : (
							<S.ContainerPreview previewImage="column">
								{files.map((file) => (
									<AttachmentCard
										key={file.guidFileImport}
										ids={{
											deleteButton: `id-files-btn-delete-${file.guidFileImport}`,
											downloadButton: `id-files-btn-download-${file.guidFileImport}`,
											comment: `id-files-comment-${file.guidFileImport}`,
										}}
										fileName={generateNameFile(file)}
										fileNameTooltip={generateTooltipMessageFile(file)}
										comment={file.comment}
										isImage={false}
										fileExtension={file.fileExtension}
										canDelete={file.canDelete}
										canDownload={file.canDownload}
										onDelete={() => onDeleteFile(file.guidQuoteAttachment)}
										onDownload={() => onDownloadFile(file.guidFileImport, generateNameFile(file), file.fileExtension)}
									/>
								))}
							</S.ContainerPreview>
						)}
					</div>
				)
			}
		/>
	);
}

export default CollapseFiles;
